var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0981 4.43947V8.18515C17.0981 8.64989 16.7753 9.02501 16.3753 9.02501C15.9754 9.02501 15.6526 8.6499 15.6526 8.18515V6.39629L10.9067 11.9111C10.6344 12.2274 10.155 12.2274 9.88277 11.9111L6.97272 8.52942L2.13305 14.1532C1.99089 14.3184 1.80536 14.3996 1.62237 14.3996C1.43685 14.3996 1.25133 14.3184 1.11169 14.1532C0.827355 13.8257 0.827355 13.2938 1.11169 12.9663L6.46243 6.74621C6.73231 6.43261 7.21411 6.43261 7.48379 6.74621L10.394 10.1306L14.5689 5.27934H13.1522C12.7548 5.27934 12.4295 4.90423 12.4295 4.43947C12.4295 3.97472 12.7546 3.59961 13.1522 3.59961H16.3757C16.7756 3.59961 17.0984 3.97472 17.0984 4.43947H17.0981Z",
    fill: "#58F2F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrement);
export default __webpack_public_path__ + "static/media/increment.de28a741ca53521207c0994fe59c4d7f.svg";
export { ForwardRef as ReactComponent };